import React, { useState } from "react";
import { useEffect } from "react";
import moment from "moment";

export default function Termo(props) {
  const [termoAtual, setTermoAtual] = useState(0);

  let clica = (t) => {
    setTermoAtual(t);
  };

  let sim = () => {
    let datetime = moment().format("DD/MM/YYYY [às] HH:mm");

    localStorage.setItem("acceptedTermDate", datetime);
    localStorage.setItem("acceptedTerm", "true");
    props.history.push("/tab/jogo");
  };

  let nao = () => {
    localStorage.setItem("isUserLogged", "");
    localStorage.setItem("acceptedTermDate", "");
    localStorage.setItem("acceptedTerm", "");
    props.history.push("/");
  };

  let openLinkPwaAndroid = () => {
    window.open("https://support.google.com/chrome/answer/9658361?co=GENIE.Platform%3DAndroid&hl=pt-BR", "_blank");
  };

  let openLinkPwaComputador = () => {
    window.open("https://support.google.com/chrome/answer/9658361?co=GENIE.Platform%3DDesktop&hl=pt-BR&oco=0", "_blank");
  };

  useEffect(() => {
    const abortController = new AbortController();

    setTermoAtual(1);

    if (
      localStorage.getItem("acceptedTerm") != null &&
      localStorage.getItem("acceptedTerm") === "true"
    ) {
      props.history.push("/tab/jogo");
    }

    return function cleanup() {
      abortController.abort();
    };
  }, [setTermoAtual, props.history]);

  return (
    <div className="menu-content pane">
      <div className="view-container">
        <div className="view-termo pane pane-game">
          <div className="bar bar-header">
            <div className="row">
              <div className="col">
                <div className="cgame-menu">
                  <b className="cgame-menu-item">
                    <span className="cgame-icon-lampada" />
                  </b>
                </div>
              </div>
              <div className="col-75">
                <div className="tab">
                  <b
                    className={
                      termoAtual === 1 ? "tab-item active" : "tab-item"
                    }
                    onClick={() => clica(1)}
                  >
                    Termos
                  </b>
                  <span>|</span>
                  <b
                    className={
                      termoAtual === 2 ? "tab-item active" : "tab-item"
                    }
                    onClick={() => clica(2)}
                  >
                    Regras
                  </b>
                  <span>|</span>
                  <b
                    className={
                      termoAtual === 3 ? "tab-item active" : "tab-item"
                    }
                    onClick={() => clica(3)}
                  >
                    FAQ
                  </b>
                </div>
              </div>
            </div>
          </div>

          <div className="scroll-content ionic-scroll">
            <div className="scroll">
              <div
                className="text-container"
                style={{ display: termoAtual === 1 ? "" : "none" }}
              >
                <h2>Termos e Condições de Uso do Game</h2>
                <h3>Aceitação dos Termos e Condições de Uso</h3>
                <p>
                  O uso do ConheciGame (a partir de agora, denominado Game) oferecido 
                  pela Universidade Corporativa Sebrae do Serviço Brasileiro de Apoio 
                  às Micro e Pequenas Empresas (a partir de agora, denominado Sebrae) 
                  está condicionado à aceitação e ao cumprimento dos Termos e Condições 
                  de Uso descritos abaixo. Para fazer uso do Game é preciso: (i) ler 
                  atentamente os termos descritos abaixo; (ii) concordar expressamente 
                  com eles. Ao fazer uso do Game oferecido pelo Serviço Brasileiro de 
                  Apoio às Micro e Pequenas Empresas (Sebrae), você (a partir de agora, 
                  denominado Usuário) concorda que leu, entendeu e aceitou os termos, as 
                  regras e as condições aqui dispostos. Os Termos e Condições de Uso 
                  regulamentam a utilização do Game, que pertencem ao Sebrae, localizado 
                  na SGAS Av. L2 Sul 604/605, Módulos 30/31, Asa Sul, Brasília/DF, 
                  devidamente inscrito no CNPJ sob o nº 00.330.845/0001-45. O Game está 
                  disponível para colaboradores do Sistema Sebrae com login de usuário 
                  no SGUS e perfil na rede social Conexão Sebrae. O Sebrae se reserva o 
                  direito de modificar, a qualquer momento, a apresentação, configuração
                  e disponibilização do Game. O mesmo se aplica a estes Termos e 
                  Condições de Uso, estabelecidos como condição fundamental para a 
                  utilização do serviço.
                </p>
                <h3>Game</h3>
                <p>
                  O Sebrae oferece ao Usuário um Game que tem o objetivo de complementar 
                  os estudos e testar os conhecimentos em formato de quiz nos seguintes
                  modos: (i) single player – em que o participante joga sozinho, on-line
                  ou off-line, e (ii) multiplayer – em que o participante poderá jogar 
                  com outros competidores que estejam on-line no momento.
                </p>
                <h3>Pontos virtuais</h3>
                <p>
                  O Game poderá incluir a oportunidade de compra de pontos virtuais 
                  (moeda in-game), que pode exigir que o Usuário execute tarefas a 
                  serem determinadas para obter a moeda virtual. A moeda virtual 
                  nunca pode ser trocada por dinheiro real, bens ou qualquer outro
                  item de valor monetário. O Usuário entende que não tem nenhum 
                  direito ou título que conquiste virtualmente no Game.
                </p>
                <h3>Gratuidade</h3>
                <p>
                  O Game é oferecido ao Usuário de forma gratuita. Os valores referentes 
                  à utilização dos serviços necessários ao acesso à internet, entre 
                  outros, são de responsabilidade exclusiva do Usuário.
                </p>
                <h3>Utilização do Game</h3>
                <p>
                  O Usuário reconhece que é responsável por quaisquer informações falsas 
                  que possam ser prestadas durante a utilização do Game. O Usuário 
                  isenta o Sebrae de qualquer responsabilidade quanto à veracidade dos
                  dados fornecidos por ele durante o uso do Game.
                </p>
                <p>
                  O usuário reconhece, ainda, que estes Termos e Condições de Uso do Game 
                  oferecidos pelo Sebrae devem ser observados e fielmente cumpridos, sob 
                  pena de cancelamento e bloqueio de utilização do Game e demais medidas 
                  cabíveis, caso os mencionados Termos sejam violados ou descumpridos. A 
                  utilização do Game não é obrigatória ao colaborador e/ou credenciado do 
                  Sistema Sebrae, é uma atividade de entretenimento e aprendizado 
                  complementar e não configura jornada de trabalho. A utilização do Game,
                  bem como os pontos adquiridos no Game, não são critérios de nota e/ou 
                  pontuação em qualquer programa da Universidade Corporativa. A utilização
                  do Game implica na aceitação das Regras do Game.
                </p>
                <h3>Registro e dados pessoais</h3>
                <p>
                  É dever do Usuário manter atualizados os dados pessoais fornecidos quando
                  da utilização do Game. O Sebrae pode cancelar qualquer registro do Usuário, 
                  a qualquer momento e sem prévio aviso, assim que tiver conhecimento, e a 
                  seu exclusivo critério, se o Usuário descumprir, intencionalmente ou não,
                  estes Termos e Condições de Uso ou violar leis e regulamentos federais,
                  estaduais e/ou municipais, ou violar os princípios legais, a moral e os
                  bons costumes.
                </p>
                <p>
                  Os Usuários que tiverem seus registros cancelados não poderão mais 
                  utilizar o Game.
                </p>
                <h3>Regras de conduta do Usuário</h3>
                <p>
                  O Game pode fornecer canais de comunicação como fóruns, comunidades
                  ou áreas de bate-papo projetado para permitir que o Usuário se 
                  comunique com outros Usuários do Serviço. O Sebrae fica desobrigado 
                  a monitorar esses canais de comunicação, mas poderá fazê-lo e se 
                  reserva o direito de rever comentários postados nos canais de 
                  comunicação e remover todos os materiais, a qualquer momento, 
                  com ou sem aviso prévio por qualquer razão, a seu exclusivo critério.
                  O Sebrae também poderá suspender qualquer acesso aos canais de 
                  comunicação a qualquer momento, sem aviso prévio, por qualquer motivo.
                  O Usuário reconhece que qualquer material ou comentário postados pelos 
                  Usuários nos canais de comunicação não são endossados nem controlados 
                  pelo Sebrae e estas comunicações não devem ser consideradas revistas 
                  ou aprovadas pelo Sebrae. O Sebrae não será sob qualquer circunstância 
                  responsável por qualquer atividade dentro de canais de comunicação. O 
                  Usuário concorda que todas as contribuições nos canais de comunicação 
                  são públicas, e, portanto, não tem nenhuma expectativa de privacidade 
                  em relação ao seu uso. O Sebrae não se responsabiliza pelas informações 
                  que o Usuário escolhe compartilhar nos Canais de Comunicação. O Usuário 
                  deverá seguir o código de boa conduta do colaborador Sebrae.
                </p>
                <p>
                  O Usuário se compromete a não utilizar o Game para a publicação,
                  criação, armazenamento e/ou divulgação de:
                </p>
                <ol className="lists-ol">
                  <li>
                    Conteúdo abusivo, como textos, fotos e/ou vídeos que tenham caráter 
                    difamatório, discriminatório, obsceno, ofensivo, ameaçador, abusivo, 
                    vexatório, prejudicial, que contenha expressões de ódio contra pessoas 
                    ou grupos, credo, cor, etnia, orientação sexual ou identidade e expressão 
                    de gênero ou que contenha pornografia infantil, pornografia explícita ou 
                    violenta, conteúdo que possa ser danoso a menores, que contenha insultos 
                    ou ameaças religiosas ou raciais, ou que incentive danos morais (incluindo 
                    os corporais) e patrimoniais, ou que possa violar qualquer direito de 
                    terceiro, notadamente os direitos humanos.
                  </li>
                  <li>
                    Banners publicitários e/ou qualquer tipo de comércio eletrônico que seja
                    considerado ilícito, assim entendidos os que sejam contrários à legislação
                    ou ofendam direitos de terceiros.
                  </li>
                  <li>
                    Qualquer tipo de material (textos, fotos e/ou vídeos) protegido por direitos
                    autorais, copyright ou que, por qualquer razão, violem direitos de terceiros.
                  </li>
                  <li>
                    Informações difamatórias e caluniosas ou que sejam contrárias à honra, à 
                    intimidade pessoal e familiar ou à imagem das pessoas (inclusive de pessoas 
                    jurídicas, entidades e organizações e ela equiparadas).
                  </li>
                  <li>
                    Material que incite à violência e à criminalidade, bem como à pirataria de 
                    produtos.
                  </li>
                  <li>
                    Conteúdo que provoque, por suas características (como extensões e formatos 
                    de arquivos) danos ao sistema do Sebrae.
                  </li>
                </ol>
                <p>O Usuário concorda que, ao usar o Game, não irá:</p>
                <ul className="lists-ul">
                  <li>violar qualquer um destes Termos e Condições de Uso;</li>
                  <li>
                    praticar falsidade, assim entendidas a falsidade de informações (i.e: divulgação
                    proposital e voluntária de informações que o Usuário saiba ser falsa ou que 
                    sejam notoriamente falsas) e a falsidade ideológica;
                  </li>
                  <li>
                    publicar ou transmitir qualquer conteúdo abusivo ou ofensivo nos comentários;
                  </li>
                  <li>
                    replicar ou armazenar conteúdo abusivo nos servidores do Sebrae;
                  </li>
                  <li>
                    fazer qualquer coisa ou praticar qualquer ato contrário à boa-fé e aos usos e 
                    costumes das comunidades virtuais e que possam ofender qualquer direito de 
                    terceiros. Por violação aos usos e costumes de comunidades virtuais também 
                    deve ser entendido o uso excessivo de texto em letras maiúsculas, uso de 
                    críticas ofensivas (conhecidas como “flamming”), a inclusão desnecessária e 
                    imprudente de comunicações anteriores em qualquer publicação ou transmissão, 
                    bem como qualquer outro ato que esteja em desacordo com a etiqueta da Internet 
                    comumente aceita.
                  </li>
                  <li>cometer fraude;</li>
                  <li>
                    violar ou infringir direitos de propriedade intelectual, direitos fiduciários 
                    ou contratuais, direitos de privacidade ou publicidade de outros;
                  </li>
                  <li>
                    propagar, distribuir ou transmitir códigos destrutivos, quer tenham ou não causado 
                    danos reais;
                  </li>
                  <li>
                    reunir dados pessoais ou comerciais, incluindo (mas não se limitando a) endereços 
                    de e-mail e/ou nomes de qualquer recurso da Internet, seja gerenciado por nós ou 
                    por terceiros, para fins comerciais, políticos, de benemerência ou outros, sem o 
                    consentimento dos proprietários desses dados;
                  </li>
                  <li>
                    reproduzir, replicar, copiar, alterar, modificar, criar obras derivativas a partir 
                    de, vender ou revender qualquer um dos serviços do Sebrae ou qualquer parte deles, 
                    incluindo websites e páginas web, ou as informações ou dados contidos nos serviços 
                    do Sebrae;
                  </li>
                  <li>
                    usar robôs, “spiders” ou qualquer outro dispositivo, automático ou manual, para 
                    monitorar ou copiar qualquer conteúdo do serviço do Sebrae;
                  </li>
                  <li>
                    transmitir conteúdo que não pertence ao Usuário ou que ele não tenha direito de 
                    publicar ou distribuir, seja sob lei ou contrato;
                  </li>
                  <li>
                    acessar o Game sem autorização, por meio de práticas de “hacking”, “password mining” 
                    ou qualquer outro meio fraudulento ou que represente violação a direito de terceiros;
                  </li>
                  <li>
                    realizar ou incentivar atividades ilegais, incluindo (mas não se limitando a) 
                    promover ou facilitar;
                  </li>
                  <li>
                    o acesso, uso ou venda de substâncias ou dispositivos perigosos;
                  </li>
                  <li>
                    deixar de cumprir com quaisquer leis, normas, regras, princípios e regulamentações 
                    aplicáveis;
                  </li>
                  <li>
                    ajudar qualquer terceiro a realizar qualquer uma das ações vedadas por estes Termos 
                    e Condições de Uso.
                  </li>
                </ul>
                <h3>Direitos de Propriedade Intelectual</h3>
                <p>
                  O Sebrae respeita os direitos de propriedade intelectual de terceiros e requer que os 
                  Usuários façam o mesmo. Ao enviar qualquer conteúdo ou informação para o Game, incluindo 
                  textos, tais como comentários, fóruns de discussão, comunidades, enquetes, testes, seção 
                  de dúvidas, participação em concurso cultural, fotografias, ilustrações, vídeos, arquivos 
                  de áudio e outros materiais, o Usuário declara autorizar de forma gratuita, não exclusiva, 
                  perpétua, global e livre de royalty o uso do material pelo Sebrae e suas empresas 
                  afiliadas e parceiras, por qualquer modalidade e suporte, para publicação, reprodução, 
                  transmissão, retransmissão, distribuição, comunicação ao público, edição, adaptação e 
                  outras transformações, tradução para qualquer idioma, inclusão em quaisquer outras obras, 
                  representação, execução, uso por radiodifusão e outros meios de comunicação, mediante o 
                  emprego de qualquer tecnologia, exposição, inclusão em base de dados e quaisquer outras 
                  modalidades de utilização existentes ou que venham a ser inventadas no futuro, em quaisquer 
                  suportes existentes ou que venham a ser inventados no futuro, autorizando também a criação 
                  de obras derivadas e o sublicenciamento do material para uso em outras plataformas de 
                  comunicação do Sebrae, sem limite de tempo e território.
                </p>
                <p>
                  Qualquer eventual omissão não implicará limitação de uso do material pelo Sebrae. Se o 
                  Usuário não concorda em autorizar o Sebrae a utilizar sua contribuição conforme acima, o 
                  Usuário então não deverá submeter qualquer material para o Game. O Sebrae não está obrigado 
                  a utilizar os materiais enviados pelo Usuário e está autorizado a editar os comentários 
                  enviados pelo Usuário. O Usuário reconhece e declara que em qualquer contribuição submetida 
                  para o Game, o material correspondente é de sua exclusiva criação, não constituindo violação 
                  de direitos autorais, marcas, segredos, direitos de personalidade, incluindo honra, 
                  intimidade, vida privada e a imagem das pessoas, direitos patrimoniais e quaisquer outros 
                  direitos de terceiros e que possui poderes para autorizar o uso do material pelo Sebrae 
                  conforme acima.
                </p>
                <p>
                  Desde que citada a fonte (inclusive o nome do autor, quando possível e aplicável) e dentro 
                  das condições e limites previstos em lei, notadamente a Lei de Direitos Autorais (Lei n.º 
                  9.610/98), o Usuário não pode reproduzir, publicar, apresentar, alugar, oferecer ou expor 
                  qualquer cópia de qualquer conteúdo pertencente ao Sebrae sem o consentimento do Sebrae ou, 
                  no caso de conteúdo de autoria de terceiros, sem o consentimento do autor ou autora. O 
                  Usuário se compromete a cumprir todas as leis nacionais e internacionais referentes aos 
                  Direitos de Propriedade Intelectual.
                </p>
                <h3>Denúncia de abusos e violação</h3>
                <p>
                  O Usuário se compromete a denunciar quaisquer abusos ou violação destes Termos e Condições 
                  de Uso ou de quaisquer direitos de terceiros que observar e/ou for vítima quando da utilização 
                  do Game. O Usuário deve utilizar o canal disponibilizado no Game para comunicação.
                </p>
                <p>
                  Todo conteúdo que o Usuário publica utilizando qualquer fórum de discussão é uma informação 
                  que, por sua natureza e característica, é pública, aberta e não confidencial. Ao revelar dados 
                  pessoais, tais como seu nome e endereço de e-mail nos comentários, o Usuário aceita e compreende 
                  que essa informação pode ser coletada e usada por outras pessoas para se comunicarem com ele, 
                  sem que seja imputável qualquer responsabilidade ao Sebrae. Desta forma, o Sebrae recomenda que 
                  o Usuário seja, portanto, cuidadoso ao decidir compartilhar qualquer dado pessoal em qualquer 
                  website.
                </p>
                <h3>Responsabilidades</h3>
                <p>
                  O Sebrae não se responsabiliza por quaisquer danos sofridos pelo Usuário ou terceiros que, de 
                  qualquer modo, tenha origem ou dependência relacionada ao Game. O Sebrae se exime de quaisquer 
                  responsabilidades sobre prejuízos resultantes de qualquer interrupção ou erro nos Games virtuais 
                  do Sebrae, incluindo a impossibilidade de acessar o Game e/ou os websites relacionados a ele.
                </p>
                <h3>Privacidade de dados</h3>
                <p>
                  O Sebrae não se responsabiliza por quaisquer danos que o Usuário possa sofrer, que tenham origem 
                  na divulgação dos dados pessoais do Usuário ou de terceiros em materiais publicados em qualquer 
                  website.
                </p>
                <p>
                  O Sebrae preserva a privacidade dos dados dos Usuários, e se compromete a revelar os dados pessoais 
                  do Usuário apenas devido a um dos seguintes motivos:
                </p>
                <ul className="lists-ul">
                  <li>por lei;</li>
                  <li>
                    por meio de uma ordem ou intimação de um órgão, autoridade ou tribunal com poderes para tanto 
                    e de jurisdição competente;
                  </li>
                  <li>
                    para garantir a segurança dos sistemas, resguardar direitos e prevenir responsabilidades do 
                    Sebrae.
                  </li>
                </ul>
                <h3>Legislação aplicável</h3>
                <p>
                  Estes Termos e Condições de Uso são governados e interpretados segundo as leis da República Federativa 
                  do Brasil e todas as disputas, ações e outros assuntos relacionados serão determinados de acordo com 
                  essa legislação.
                </p>
                <h3>Política de Privacidade</h3>
                <p>
                  A política de privacidade tem como objetivo deixar claro o compromisso do Sebrae em garantir a proteção 
                  dos dados solicitados. Para navegar em áreas restritas do Game e ter acesso a serviços exclusivos, o 
                  usuário precisa ter acesso (login e senha) do SGUS. Não fornecemos suas informações pessoais para 
                  terceiros sem a sua autorização e não divulgamos informações que possam identificar os usuários. 
                  Somente dados genéricos e agregados, referentes à quantidade de pessoas que acessam áreas dos nossos 
                  sites, podem ser divulgados. Utilizamos seu e-mail apenas para enviar newsletters ou para informar e 
                  divulgar, desde que você nos dê autorização para isso. Essas regras sobre privacidade se aplicam apenas 
                  ao ConheciGame. Elas não valem para os sites do Sistema Sebrae. Você deve se informar sobre a política 
                  de cada um deles antes de fornecer qualquer tipo de informação.
                </p>
              </div>
              <div
                className="text-container"
                style={{ display: termoAtual === 2 ? "" : "none" }}
              >
                <h2>Regras</h2>
                <p>
                  O ConheciGame é um aplicativo gratuito onde os colaboradores
                  do Sebrae podem complementar seus estudos e testar seus
                  conhecimentos em formato de Quiz. O game apresenta dois modos,
                  sendo que um deles deve ser selecionado pelo usuário no início
                  da jogada:
                </p>
                <ul className="lists-ul">
                  <li>
                    <strong>Modo single player</strong> — onde o participante
                    joga sozinho, on-line ou off-line.
                  </li>
                  <li>
                    <strong>Modo Multiplayer</strong> — o participante poderá
                    jogar com outros competidores que estejam on-line no
                    momento.
                  </li>
                </ul>
                <h3>INICIANDO O GAME</h3>
                <p>
                  Para iniciar, o jogador deverá fazer o login com os mesmos
                  dados de acesso do portal UC. (CPF e Senha)
                </p>
                <p>
                  Ao fazer login no aplicativo, o jogador terá acesso ao Termo
                  de Aceite. Ao confirmar o aceite, o jogo terá início. O aceite
                  é dado somente no primeiro acesso do usuário ao game.
                </p>
                <p>
                  O jogador deverá escolher o conteúdo sobre o qual deseja
                  complementar seus estudos e, em seguida, selecionar o modo
                  Single Player ou Multiplayer
                </p>
                <h3>JOGANDO O MODO SINGLE PLAYER</h3>
                <ol className="lists-ol">
                  <li>
                    Ao optar por jogar o modo single player, o jogador deverá
                    selecionar na tela “Não Pertube” se deseja ou não receber
                    convites para jogar com outros jogadores no modo multiplayer
                    enquanto estiver estudando. Se clicar em “Sim”, ele ficará
                    disponível para partidas multiplayer ao encerrar sua lista
                    de perguntas.
                  </li>
                  <li>
                    Aor selecionado o tema, será apresentado um painel com 30
                    perguntas.
                  </li>
                  <li>
                    A cada sequência de respostas corretas a pontuação do
                    jogador é multiplicada conforme abaixo:
                    <ul className="lists-ul">
                      <li>
                        2 respostas sequenciais respondidas corretamente: o
                        valor da pergunta é multiplicada por dois;
                      </li>
                      <li>
                        3 ou mais respostas sequenciais respondidas
                        corretamente: o valor da pergunta é multiplicada por
                        cinco.
                      </li>
                    </ul>
                  </li>
                  <li>
                    A cada 10 perguntas corretas, o jogador recebe uma
                    bonificação de 10 pontos.
                  </li>
                  <li>
                    O game apresenta 30 perguntas por tema selecionado. Quando o
                    jogador responder às 30 perguntas, o referido tema será
                    sinalizado como concluído na área de seleção de temas.
                  </li>
                  <li>
                    O jogador poderá sair do aplicativo e retornar quando
                    desejar, continuando de onde parou, exceto durante a
                    resposta de uma pergunta.
                  </li>
                  <li>
                    Antes de responder a uma pergunta o jogador escolhe o nível
                    de dificuldade, relacionado ao tempo que terá para responder
                    a próxima pergunta. As opções são 120, 90 ou 60 segundos. As
                    respostas corretas respondidas em até:
                    <ul className="lists-ul">
                      <li>120 segundos = 1 ponto cada</li>
                      <li>90 segundos = 2 pontos cada</li>
                      <li>60 segundos = 3 pontos cada.</li>
                    </ul>
                  </li>
                  <li>
                    Os pontos acumulados no modo single player poderão ser
                    utilizados no modo multiplayer para acionar as opções
                    blackout e tirar 2 erradas.
                  </li>
                  <li>
                    A cada 3 questões respondidas erradas, o acesso ao tema
                    correspondente será bloqueado até que o jogador acesso o
                    item Material de Estudo, localizado no topo do game.
                  </li>
                </ol>
                <h3>JOGANDO NO MODO MULTIPLAYER</h3>
                <ol className="lists-ol">
                  <li>
                    No modo multiplayer um jogador poderá desafiar outro que
                    esteja on-line para uma disputa.
                  </li>
                  <li>
                    A batalha será sobre o tema que o jogador desafiante
                    escolher no menu inicial.
                  </li>
                  <li>
                    O sistema buscará um jogador que esteja disponível para
                    disputar uma partida.
                  </li>
                  <li>
                    O jogador desafiado receberá um aviso de desafio. Ele pode
                    aceitar ou não. Em caso positivo, o jogo começa; se ele
                    negar, o sistema escolhe outro jogador on-line
                    aleatoriamente.
                  </li>
                  <li>Os dois jogadores disputam simultaneamente.</li>
                  <li>
                    São 10 perguntas por partida. Quem responder o maior número
                    de perguntas corretamente e em menor tempo ganha a partida.
                  </li>
                  <li>
                    Em uma partida o jogador conta com dois tipos de ajuda.
                    <ul className="lists-ul">
                      <li>
                        Blackout — ao ser acionada, a tela do adversário fica
                        escura por 2 segundos. É necessário que o jogador tenha,
                        no mínimo, 50 pontos para usar essa opção.
                      </li>
                      <li>
                        Elimine 2 respostas — ao ser acionada, 2 respostas
                        erradas são apagadas das opções. É necessário que o
                        jogador tenha, no mínimo, 50 pontos para usar essa
                        opção.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Cada pergunta tem um tempo máximo de 60 segundos para
                    resposta.
                  </li>
                  <li>
                    A pontuação de cada resposta correta é 1 ponto.. No caso de
                    resposta errada, a pontuação da pergunta é igual a zero.
                  </li>
                  <li>
                    Caso o oponente desista da partida, o jogador vencerá o jogo
                    por W.O. - termo usualmente aplicado quando a vitória é dada
                    a um competidor em virtude da desistência do outro.
                  </li>
                  <li>O vencedor da partida recebe 30 pontos.</li>
                  <li>
                    Ao final de cada partida o jogador pode:
                    <ul className="lists-ul">
                      <li>Jogar novamente com o mesmo adversário</li>
                      <li>Jogar com outro adversário</li>
                      <li>Sair do modo multiplayer</li>
                    </ul>
                  </li>
                </ol>
                <h3>MENU DO JOGO</h3>
                <p>
                  Na parte superior da tela, se apresenta o menu do jogo com os
                  itens
                  <strong>
                    MENU INICIAL, RANKING, MATERIAL DE ESTUDO E MENU LATERAL.
                  </strong>
                </p>
                <h3>MENU INICIAL</h3>
                <p>
                  Nesse menu é possível escolher o conteúdo do jogo. Atualmente
                  há apenas a opção “Certificação do Conhecimento”.
                </p>
                <h3>MATERIAL DE ESTUDO</h3>
                <p>
                  Nesta opção do menu, o jogador terá acesso a um material
                  especialmente selecionado para auxílio em sua preparação para
                  o Game. Ao acessar o material de estudo, o jogador será
                  direcionado para um endereço eletrônico (site) externo.
                </p>
                <h3>RANKING</h3>
                <p>
                  Serão apresentados rankings para ambos os modos, sendo
                  caracterizados por:
                </p>
                <ul className="lists-ul">
                  <li>
                    <strong>Ranking Single Player</strong> – por número de
                    pontos acumulados
                  </li>
                  <li>
                    <strong>Ranking Multiplayer</strong> – por número de
                    partidas vencidas
                  </li>
                </ul>
                <h3>MENU LATERAL</h3>
                <p>
                  Nesta opção são apresentadas as demais funcionalidades do
                  Game:
                  <strong>PERFIL, REGRAS, FAQ, TERMO, SOBRE e SAIR.</strong>
                </p>
                <h3>PERFIL</h3>
                <p>
                  Nesse menu, o jogador terá acesso a suas estatísticas de
                  acerto dentro dos temas dos conteúdos, acessos rápidos de
                  documentação do jogo e, poderá ainda, sugerir perguntas para
                  compor o banco de questões do jogo.
                </p>
                <h3>REGRAS</h3>
                <p>Apresenta as regras gerais do jogo.</p>
                <h3>FAQ</h3>
                <p>
                  Perguntas frequentes sobre instalação e uso do aplicativo.
                </p>
                <h3>TERMO DE ACEITE</h3>
                <p>
                  Condições gerais do game que deve ser aceito pelo jogador
                  antes de utilizar o aplicativo. Ao final do Termo de Aceite é
                  possível conhecer a data e horário que o jogador fez o aceite
                  do referido termo.
                </p>
                <h3>SOBRE</h3>
                <p>
                  Exibe informações técnicas sobre o usuário logado, o
                  dispositivo utilizado, característica da tela e tipo de
                  conexão com a internet.
                </p>
                <h3>SAIR</h3>
                <p>
                  Ao acionar essa opção o usuário sairá do aplicativo. Ao
                  utilizar essa opção, o usuário terá que fazer novo login no
                  próximo acesso.
                </p>
                <br />
                <br />
              </div>
              <div
                className="text-container"
                style={{ display: termoAtual === 3 ? "" : "none" }}
              >
                <h2>Perguntas Frequentes</h2>
                <br />
                <h3>1. Como instalo meu aplicativo?</h3>
                <p>
                  Você pode utilizar o conhecigame apenas acessando a url em seu navegador, seja pelo 
                  desktop ou celular. Caso queira manter um atalho para o jogo, basta seguir as 
                  instruções abaixo:
                </p>
                <div 
                  className="link-faq"
                  onClick={() => openLinkPwaAndroid()} >
                  Como usar Progressive Web Apps no <b>Android</b>
                </div>
                <div 
                  className="link-faq"
                  onClick={() => openLinkPwaComputador()} >
                  Como usar Progressive Web Apps no <b>Computador</b>
                </div>
                <h3>
                  2. Não consigo jogar porque recebo constantemente o aviso “Erro de conexão”. 
                  O que devo fazer?
                </h3>
                <p>
                  O aviso de “Erro de conexão. Tente novamente.” aponta que você está utilizando uma conexão 
                  instável com a internet. Você conseguirá jogar com uma conexão com a internet ruim, mas 
                  receberá os avisos de “Erro de conexão. Tente novamente.”. Para continuar o jogo, é necessário 
                  fechar o aviso clicando no “x” e selecionar novamente a reposta que já tinha escolhido (caso 
                  esteja na tela em que você deve responder uma pergunta).
                </p>
                <h3>
                  3. Como vejo qual é a versão que estou utilizando do ConheciGame?
                </h3>
                <p>
                  O número da versão do aplicativo está na aba “Sobre” (penúltima opção do menu lateral à direita).
                </p>
                <h3>
                  4. O aplicativo funciona em quais ambientes?
                </h3>
                <p>
                  A versão atual do aplicativo é compatível com os navegadores:
                </p>
                <ul className="lists-ul">
                  <li>
                    Chrome a partir da versão 40
                  </li>
                  <li>
                    Edge a partir da versão 79
                  </li>
                  <li>
                    Firefox a partir da versão 44
                  </li>
                  <li>
                    Chorme para Android a partir da versão 86
                  </li>
                  <li>
                    Android Browser a partir da versão 81
                  </li>
                  <li>
                    iOS Safari a partir da versão 14
                  </li>
                </ul>
                <br />
                <br />
              </div>
            </div>
          </div>

          <div className="footer">
            <div className="row">
              <div className="col">
                <h2 className="ng-binding">Aceita o termo?</h2>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="button" onClick={() => sim()}>
                  Sim
                </div>
              </div>
              <div className="col">
                <div className="button" onClick={() => nao()}>
                  Não
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
